import Stores from 'Stores'

export const correctStyleLessons = (state) => {
  if (Stores.isClient) return ''
  return state ? 'lessonQuestion__correctAnswer' : 'lessonQuestion__wrongAnswer'
}
